// 编辑区域 undo redo 管理

import FJUndoRedoManager from '../../../../core/FJUndoRedoManager';

class CreationEditUndoRedoManager extends FJUndoRedoManager {
    constructor() {
        super();
    }
}

const FJCreationEditUndoRedoManager = new CreationEditUndoRedoManager();
export default FJCreationEditUndoRedoManager;
